export const NAV_LINKS = [
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Hizmetlerimiz", href: "#hizmetler" },
  { label: "Kadromuz", href: "#kadromuz" },
  { label: "İletişim", href: "#iletisim" },
];

export const HERO = {
  overline: "T.C. Sağlık Bakanlığı — Aksaray Merkez",
  lines: ["Taşpınar", "Aile Sağlığı", "Merkezi."],
  sub: "Aksaray Merkez Taşpınar Erenler Mahallesi'nde; hasta muayenesinden laboratuvar tetkiklerine, birinci basamak sağlık hizmetlerini güler yüzle sunuyoruz.",
  image: "/images/02-dis-cephe-rampa.webp",
  imageAlt: "Taşpınar Aile Sağlığı Merkezi dış cephesi ve erişilebilirlik rampası",
};

export const MARQUEE_ITEMS = [
  "HASTA MUAYENESİ",
  "ANNE SÜTÜ BİLGİLENDİRME",
  "HASTA SEVK İŞLEMLERİ",
  "SAĞLIK RAPORU",
  "ENJEKSİYON — PANSUMAN",
  "LABORATUVAR TETKİKLERİ",
  "AİLE PLANLAMASI",
  "KÜÇÜK CERRAHİ MÜDAHALELER",
  "HASTA HAKLARI",
];

export const SERVICES = [
  {
    icon: "Stethoscope",
    title: "Hasta Muayenesi",
    desc: "Merkezimize kayıtlı tüm hastalarımızın muayene, tanı ve tedavi işlemleri hekimimiz tarafından yürütülür.",
    span: "md:col-span-7",
    image: "/images/08-hekim-muayene-odasi.webp",
  },
  {
    icon: "Baby",
    title: "Anne Sütü Hakkında Bilgilendirme",
    desc: "Annelerimize emzirme ve anne sütünün önemi konusunda bilgilendirme ve danışmanlık verilir.",
    span: "md:col-span-5",
  },
  {
    icon: "ArrowRightLeft",
    title: "Hasta Sevk İşlemleri",
    desc: "İleri tetkik ve tedavi gereken durumlarda üst basamak sağlık kuruluşlarına sevk işlemleri yapılır.",
    span: "md:col-span-5",
  },
  {
    icon: "FileText",
    title: "Tek Hekim Sağlık Raporu Verilmesi",
    desc: "İşe giriş, okul, spor ve benzeri durumlar için tek hekim sağlık raporları düzenlenir.",
    span: "md:col-span-7",
  },
  {
    icon: "Syringe",
    title: "Enjeksiyon — Pansuman",
    desc: "Enjeksiyon ve pansuman hizmetleri merkezimizde uygulanır.",
    span: "md:col-span-4",
  },
  {
    icon: "FlaskConical",
    title: "Çeşitli Laboratuvar Tetkikleri",
    desc: "Çeşitli tetkik ve tahliller için numune alımı merkezimizde gerçekleştirilir.",
    span: "md:col-span-4",
  },
  {
    icon: "HeartHandshake",
    title: "Aile Planlaması",
    desc: "Aile planlaması yöntemleri hakkında danışmanlık ve hizmet sunulur.",
    span: "md:col-span-4",
  },
  {
    icon: "Scissors",
    title: "Küçük Cerrahi Müdahaleler",
    desc: "Küçük cerrahi müdahaleler merkezimizde güvenle gerçekleştirilir.",
    span: "md:col-span-7",
  },
  {
    icon: "ShieldCheck",
    title: "Hasta Hakları Başvurularını Değerlendirme",
    desc: "Hasta hakları başvurularınız merkezimizce değerlendirilir ve sonuçlandırılır.",
    span: "md:col-span-5",
  },
];

export const TEAM = {
  overline: "Kadromuz",
  title: "Kadromuz",
  members: [
    { no: "01", name: "Dr. Burak KÖSE", role: "Aile Hekimi" },
    { no: "02", name: "Emine Nur DAĞ", role: "Ebe" },
    { no: "03", name: "Seda KORKUT", role: "Yardımcı Sağlık Personeli" },
    { no: "04", name: "Melek ATİLA", role: "Temizlik Personeli" },
  ],
};

export const GALLERY = {
  overline: "Hakkımızda",
  title: "Merkezimizden Kareler",
  featured: {
    src: "/images/01-dis-cephe-giris.webp",
    alt: "Taşpınar Aile Sağlığı Merkezi ön girişi",
  },
  images: [
    {
      src: "/images/01-dis-cephe-giris.webp",
      alt: "Taşpınar Aile Sağlığı Merkezi ön girişi",
      caption: "Kurum girişi",
    },
    {
      src: "/images/02-dis-cephe-rampa.webp",
      alt: "Taşpınar Aile Sağlığı Merkezi dış cephesi ve erişilebilirlik rampası",
      caption: "Dış cephe ve erişim rampası",
      orientation: "landscape",
    },
    {
      src: "/images/03-bekleme-koridoru.webp",
      alt: "Taşpınar Aile Sağlığı Merkezi bekleme koridoru",
      caption: "Bekleme koridoru",
    },
    {
      src: "/images/04-asm-giris-alani.webp",
      alt: "ASM logosunun bulunduğu ana giriş alanı",
      caption: "Ana giriş alanı",
    },
    {
      src: "/images/05-bilgilendirme-panosu.webp",
      alt: "Aile hekimliği bilgilendirme panosu",
      caption: "Bilgilendirme panosu",
    },
    {
      src: "/images/06-danisma-bekleme-alani.webp",
      alt: "Merkezin danışma ve bekleme alanı",
      caption: "Danışma ve bekleme",
    },
    {
      src: "/images/07-anne-bebek-bekleme-alani.webp",
      alt: "Anne ve bebek sağlığı bilgilendirme bekleme alanı",
      caption: "Anne ve bebek bekleme alanı",
    },
    {
      src: "/images/08-hekim-muayene-odasi.webp",
      alt: "Hekim muayene odası",
      caption: "Hekim muayene odası",
    },
    {
      src: "/images/09-hekim-calisma-odasi.webp",
      alt: "Hekim çalışma ve muayene odası",
      caption: "Hekim çalışma alanı",
    },
    {
      src: "/images/10-muayene-takip-odasi.webp",
      alt: "Hasta muayene ve takip odası",
      caption: "Muayene ve takip odası",
    },
    {
      src: "/images/11-muayene-ekipmanlari.webp",
      alt: "Muayene odası ve tıbbi ekipmanlar",
      caption: "Muayene ekipmanları",
    },
    {
      src: "/images/12-muayene-mudahale-odasi.webp",
      alt: "Hasta muayene ve müdahale odası",
      caption: "Muayene ve müdahale",
    },
    {
      src: "/images/13-tibbi-mudahale-odasi.webp",
      alt: "Tıbbi müdahale odası",
      caption: "Tıbbi müdahale odası",
    },
    {
      src: "/images/14-saglik-takip-odasi.webp",
      alt: "Sağlık takip ve ölçüm odası",
      caption: "Sağlık takip alanı",
    },
    {
      src: "/images/15-tibbi-cihaz-odasi.webp",
      alt: "Tıbbi cihazların bulunduğu takip odası",
      caption: "Tıbbi cihaz alanı",
    },
    {
      src: "/images/16-kadin-sagligi-odasi.webp",
      alt: "Kadın sağlığı ve takip odası",
      caption: "Kadın sağlığı odası",
    },
    {
      src: "/images/17-bebek-izlem-odasi.webp",
      alt: "Bebek izlem ve bakım odası",
      caption: "Bebek izlem odası",
    },
    {
      src: "/images/18-ic-koridor.webp",
      alt: "Klinik odalara açılan iç koridor",
      caption: "İç koridor",
    },
    {
      src: "/images/19-klinik-giris.webp",
      alt: "Muayene odası giriş alanı",
      caption: "Klinik giriş alanı",
    },
    {
      src: "/images/20-klinik-gecis-alani.webp",
      alt: "Merkez içindeki klinik geçiş alanı",
      caption: "Klinik geçiş alanı",
    },
    {
      src: "/images/21-emzirme-odasi.webp",
      alt: "Taşpınar Aile Sağlığı Merkezi emzirme odası girişi",
      caption: "Emzirme odası",
    },
    {
      src: "/images/22-tuvalet-1.webp",
      alt: "Taşpınar Aile Sağlığı Merkezi tuvalet girişi",
      caption: "Tuvalet",
    },
    {
      src: "/images/23-tuvalet-2.webp",
      alt: "Taşpınar Aile Sağlığı Merkezi ikinci tuvalet girişi",
      caption: "Tuvalet",
    },
  ],
};

export const CONTACT = {
  phone: "0543 890 10 68",
  address: ["Taşpınar Erenler Mah. Şehit Yücel Demirtaş Sok. No:3", "Merkez / Aksaray"],
  hours: [
    { day: "Hafta İçi", time: "08:00 — 17:00" },
    { day: "Öğle Arası", time: "12:00 — 13:00" },
    { day: "Hafta Sonu", time: "Kapalı" },
  ],
  emergency: "Acil durumlarda 112'yi arayınız.",
  mapEmbed: "https://maps.google.com/maps?q=38.175819,34.04295&z=16&output=embed",
  provincialDirectorate: {
    name: "Aksaray İl Sağlık Müdürlüğü",
    phones: [
      { label: "0382 222 01 10", href: "tel:+903822220110" },
      { label: "0382 222 01 11", href: "tel:+903822220111" },
      { label: "0382 222 01 12", href: "tel:+903822220112" },
    ],
    fax: "0382 222 01 16",
    email: "aksaray@saglik.gov.tr",
    kep: "aksarayism@hs01.kep.tr",
    address: "Zafer Mahallesi 22/Nevşehir Caddesi No:115 Merkez / Aksaray",
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=Zafer+Mahallesi+22%2FNev%C5%9Fehir+Caddesi+No%3A115+Merkez+Aksaray",
  },
};
